
import React, { useState } from 'react';
import { 
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger 
} from "@/components/ui/tooltip";
import { Info } from 'lucide-react';

interface MetricTooltipProps {
  tooltip: string;
}

const MetricTooltip: React.FC<MetricTooltipProps> = ({ tooltip }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltipToggle = () => {
    setTooltipOpen(prev => !prev);
  };

  return (
    <TooltipProvider>
      <Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
        <TooltipTrigger asChild>
          <button 
            className="absolute top-2 right-2 p-2 cursor-help" 
            aria-label="Info"
            onClick={handleTooltipToggle}
          >
            <Info size={16} className="text-gray-400" />
          </button>
        </TooltipTrigger>
        <TooltipContent 
          className="max-w-[250px] text-xs" 
          sideOffset={5}
          onPointerDownOutside={() => setTooltipOpen(false)}
          onEscapeKeyDown={() => setTooltipOpen(false)}
        >
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default MetricTooltip;
